import { NOTIFICATION_CHANNEL } from "@nlc/shared-types";
import { SuprSend } from "@suprsend/react";
import { useEffect, useState } from "react";

import { env } from "@/config/env";
import { useUser } from "@/hooks/useUser";

import { useConnectChannel } from "../../hooks/useConnectChannel";
import { showToast, ToastTypeEnum } from "../utils/showToast";
import ConnectButton from "./ConnectButton";

type Permission = "denied" | "granted";

export default function WebPushConfig({
  isActive,
  isDisabled,
}: {
  isActive: boolean;
  isDisabled: boolean;
}) {
  const { data: user } = useUser();
  const [permission, setPermission] = useState<Permission>("denied");
  const suprSendClient = new SuprSend(env.VITE_SUPRSEND_PUBLIC_KEY, {
    vapidKey: env.VITE_SUPRSEND_VAPID_KEY,
  });
  const { mutate: connectChannel } = useConnectChannel();

  const isWebPushConfigured = isActive;

  useEffect(() => {
    if (!("Notification" in window)) return;

    const permission = suprSendClient.webpush.notificationPermission();

    if (permission === "granted") {
      setPermission("granted");
    } else {
      setPermission("denied");
    }
  }, []);

  const showHandleButton = !isWebPushConfigured || permission === "denied";

  const handleRegisterPush = async () => {
    if (!("Notification" in window)) return;

    try {
      if (permission !== "granted") {
        const newPermission = await Notification.requestPermission();

        if (newPermission !== "granted") {
          return;
        }
      }

      await suprSendClient.identify(user?.user.email);
      const res = await suprSendClient.webpush.registerPush();

      if (res?.body["status"] === "success") {
        connectChannel(NOTIFICATION_CHANNEL.WEBPUSH);
        showToast("Web push has been updated", ToastTypeEnum.SUCCESS);
      }

      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (showHandleButton) {
    return (
      <ConnectButton
        content={isWebPushConfigured ? "Allow" : "Connect"}
        isDisabled={isDisabled}
        onPress={handleRegisterPush}
      />
    );
  }
}
